import ReportLayoutSmall from 'images/ReportLayoutSmall.svg';
import ReportLayoutMedium from 'images/ReportLayoutMedium.svg';
import ReportLayoutLarge from 'images/ReportLayoutLarge.svg';

const SECTION_LAYOUT_2 = '2 Photos per Page';
const SECTION_LAYOUT_3 = '3 Photos per Page';
const SECTION_LAYOUT_4 = '4 Photos per Page';

export const LAYOUT_MAX_CHARS = {
  [SECTION_LAYOUT_2]: 750,
  [SECTION_LAYOUT_3]: 400,
  [SECTION_LAYOUT_4]: 260,
};

export const LAYOUT_IMAGES = {
  [SECTION_LAYOUT_2]: ReportLayoutLarge,
  [SECTION_LAYOUT_3]: ReportLayoutMedium,
  [SECTION_LAYOUT_4]: ReportLayoutSmall,
};

export const NEW_SECTION_DEFAULTS = {
  type: 'ASSET_SECTION',
  name: 'Section 1',
  position: 2,
};

export const REPORT_TEMPLATE_FEATURE_FLAG = 'report_templates';

export const SETTINGS = 'settings';
export const SECTION = 'ASSET_SECTION';
export const CONTAINER = 'ASSET_CONTAINER';
export const COVER = 'COVER_PAGE';
export const SHARE_MODAL = 'SHARE_MODAL';
export const PRINT_MODAL = 'PRINT_MODAL';
export const TEMPLATE_MODAL = 'TEMPLATE_MODAL';
export const TEMPLATES_PER_PAGE = 15;

export const DOC_TYPE = 'Report';
